import React, { useState } from "react";
import config from "../config";

export default function Login({ setUser, setIsAuthenticated }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch(`${config.apiUrl}adminapi.php?option=1`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, password }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.user) {
          setUser(data.user);
          setIsAuthenticated(true);
        } else {
          console.error("Login failed:", data.error);
          setErrorMessage(data.error);
          setShowError(true);

          // Hide the response message after 5 seconds
          setTimeout(() => {
            setShowError(false);
            setErrorMessage("");
          }, 5000);
        }
      })
      .catch((error) => console.error("Login error:", error));
  };

  return (
    <>
      <div
        className="d-flex justify-content-center align-items-center bg-body-secondary"
        style={{ height: "100vh" }}
        dir="ltr"
      >
        <div className="bg-white p-5 rounded-4">
          <h2 className="text-center fw-bold mb-4">LOGIN</h2>
          <form onSubmit={handleSubmit}>
            <div
              className="form-group d-flex mb-3"
              style={{ height: "2.5rem", minWidth: "15rem" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                className="bi bi-person-fill border rounded p-1"
                viewBox="0 0 16 16"
              >
                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
              </svg>
              <input
                type="text"
                name="username"
                id="username"
                className="form-control form-group-control-user"
                placeholder="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div
              className="form-group d-flex mb-3"
              style={{ height: "2.5rem", minWidth: "15rem" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="bi bi-shield-lock-fill border rounded p-1"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M3.5 11.5a3.5 3.5 0 1 1 3.163-5H14L15.5 8 14 9.5l-1-1-1 1-1-1-1 1-1-1-1 1H6.663a3.5 3.5 0 0 1-3.163 2zM2.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
              </svg>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                id="password"
                className="form-control form-group-control-user"
                placeholder="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                onChange={toggleShowPassword}
                id="flexCheckDefault"
              />
              <label className="form-check-label" htmlFor="flexCheckDefault">
                Show password
              </label>
            </div>
            <div
              className="form-group d-flex mb-3"
              style={{ height: "2.5rem", minWidth: "15rem" }}
            >
              <button className="w-100 btn btn-primary" type="submit">
                Log in
              </button>
            </div>
            {showError && (
              <div className="alert alert-danger" role="alert">
                {errorMessage}
              </div>
            )}
          </form>
        </div>
      </div>
    </>
  );
}
